import React from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import qs from 'qs';
import { getSession } from 'tools/WebTool';
import ROUTE_PATH from './config';
import { useApp } from '../contexts/AppContext';

const AuthRouteOutlet = ({ mode = '', ...rest }) => {
  const { auth } = useApp();
  const location = useLocation();
  const loginUrl = ROUTE_PATH.login.login;
  const homeUrl = '/';
  const sessionExists = !!getSession();

  const currentPath = location.pathname + location.search;
  const redirectQuery = '?' + qs.stringify({ 'redirect-to': currentPath });

  if (mode === 'auth') {
    // auth. 로그인 필요
    if (!auth.authenticated) {
      if (sessionExists)
        // todo: auth 개선 후 해당 코드 점검
        // todo: 현재는 auth와 session 타이밍 문제로 auth를 한 번더 태워 줌
        return <>{auth.authenticated ? <Outlet {...rest} /> : <></>}</>;
      return <Navigate to={loginUrl + redirectQuery} replace />;
    }
    return <Outlet {...rest} />;
  }

  if (mode === 'guest') {
    // guest. 로그인하면 안 되는 페이지 (예: 로그인, 회원가입)
    if (auth.authenticated) {
      const qo = qs.parse(location.search, { ignoreQueryPrefix: true });
      const rawRedirect = qo['redirect-to'];
      const redirectTo =
        typeof rawRedirect === 'string' ? rawRedirect : homeUrl;
      return <Navigate to={redirectTo} />;
    }
    return <Outlet {...rest} />;
  }

  // public. 로그인 여부 상관없는 페이지
  return <Outlet {...rest} />;
};

export { AuthRouteOutlet };
